//RBW_20260820 - Resolved presentation of a SIM status (icon + colour + friendly text)

export interface SimStatusDisplay {
  colourClass  : string;
  iconClass    : string;
  status       : string;
  statusDisplay: string;
  statusIcon   : string;
};

export function SimStatusDisplay_EmptyObject(): SimStatusDisplay {
  return {
    colourClass  : "",
    iconClass    : "",
    status       : "",
    statusDisplay: "",
    statusIcon   : "",
  }
};
